import { Box, Typography, Backdrop, Button } from '@mui/material';
import { clampIsoDateToToday, getTodayIsoDate } from "../../../utils/reportDateLimits";
import CircularProgress from "@mui/material/CircularProgress";
import { createColumnHelper } from '@tanstack/react-table';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import XLSX, { boldRows } from "utils/xlsxStyled";
import eOpsLogo from '../../../images/eops.png';
import excel from '../../../images/excel.png';
import pdf from '../../../images/pdf.png';
import print from '../../../images/print.png';
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.jpg";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import { cfpBaseUrl } from '../../../network/urls';
import { convertDate, convertDatewithTime, getName, subdivisionName } from '../../../services/Functions';
import { internalIconStyles } from '../../../style/common';
import '../../../style/common.scss';

const APMSComplaintsSummary = () => {

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const columnHelper = createColumnHelper();
  const { token, code, name, roleName, roleTypeName, cscID, cfcLevelId, divisionCode, hierarchy: userHierarchy } = useSelector(state => state.auth)
  const tableRef = useRef(null);
  const [assmntBatchWise, setAssmntBatchWise] = useState([]);
  const offCode = userHierarchy == 1
    ? code
    : userHierarchy == 2
      ? code.slice(0, 2)
      : userHierarchy == 3
        ? code.slice(0, 3)
        : userHierarchy == 4
          ? code.slice(0, 4)
          : userHierarchy == 5
            ? code.slice(0, 5)
            : code;
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [circleCode, setCircleCode] = useState('');
  const [circleName, setCircleName] = useState('');
  const [officeCode, setOfficeCode] = useState();
  const [officeName, setOfficeName] = useState('');
  const [selectedDivision, setSelectedDivision] = useState('');
  const [selectedSubDivision, setSelectedSubDivision] = useState('');
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [hierarchy, setHierarchy] = useState('');
  const [filteredCircles, setFilteredCircles] = useState([]);
  const [isGoDisabled, setIsGoDisabled] = useState(true);
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
  const [dateFrom, setDateFrom] = useState(getCurrentDate())
  const [dateTo, setDateTo] = useState(getCurrentDate())
  const [totals, setTotals] = useState({});

  const [subDivisions, setSubDivisions] = useState(JSON.parse(window.localStorage.getItem('subDivisions')) || []);
  const [selectedCompanyCode, setSelectedCompanyCode] = useState('');

  const OffLevel = String(officeCode).length;

  const companyCode = code.slice(0, 2)

  const getLogo = (code) => {
    switch (code) {
      case '11':
        return LESCOLOGO
      case '12':
        return GEPCOLOGO
      case '13':
        return FESCOLOGO
      case '14':
        return IESCOLOGO
      case '15':
        return MEPCOLOGO
      case '16':
        return PESCOLOGO
      case '27':
        return SEPCOLOGO
      case '37':
        return HESCOLOGO
      case '48':
        return QESCOLOGO
      case '59':
        return TESCOLOGO
      default:
        return MEPCOLOGO
    }
  }

  const getCompanies = (code) => {
    switch (code) {
      case '11':
        return "Lahore Electric Supply Company"
      case '12':
        return "Gujranwala Electric Power Company"
      case '13':
        return "Faisalabad Electric Supply Company"
      case '14':
        return "Islamabad Electric Supply Company"
      case '15':
        return "Multan Electric Power Company"
      case '16':
        return "Peshawar Electric Supply Company"
      case '27':
        return "Sukkur Electric Power Company"
      case '37':
        return "Hyderabad Electric Supply Company"
      case '48':
        return "Quetta Electric Supply Company"
      case '59':
        return "Tribal Electric Supply Company"
      default:
        return "Multan Electric Power Company"
    }
  }

  const DownloadPdf = async (print) => {
    return new Promise((resolve, reject) => {
      let offName = officeName || "MEPCO Region";
      let dateToPrint = getCurrentDateFormatted(new Date());
      const title = dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
        ? `APMS Complaints Summary Report of ${dateFrom}`
        : `APMS Complaints Summary Report from ${dateFrom ? convertDate(dateFrom) : '-'} to ${dateTo ? convertDate(dateTo) : '-'}`;
      const headers = [
        [
          OffLevel == 2
            ? "Circle"
            : OffLevel == 3
              ? "Division"
              : OffLevel == 4
                ? "Sub-Division"
                : OffLevel == 5
                  ? "Sub-Division"
                  : "",
          'Total',
          'New',
          'Resolved',
          'Pending',
          'Escalated',
          'Reopen',
          'On Hold'
        ].map((header) => ({
          content: header,
          styles: { halign: "center", fontStyle: "bold" },
        })),
      ];

      const body = [];

      if (tableData && tableData.length > 0) {
        tableData.forEach((item) => {
          body.push([
            { content: item.OfficeName || "-", styles: { halign: "left" } },
            { content: formatWithCommas(item.Total || 0), styles: { halign: "center" } },
            { content: formatWithCommas(item.New || 0), styles: { halign: "center" } },
            { content: formatWithCommas(item.Resolved || 0), styles: { halign: "center" } },
            { content: formatWithCommas(item.Pending || 0), styles: { halign: "center" } },
            { content: formatWithCommas(item.Escalated || 0), styles: { halign: "center" } },
            { content: formatWithCommas(item.Reopen || 0), styles: { halign: "center" } },
            { content: formatWithCommas(item.OnHold || 0), styles: { halign: "center" } },
          ]);
        });

        const totalTotal = tableData.reduce((sum, item) => sum + (item.Total || 0), 0);
        const totalNew = tableData.reduce((sum, item) => sum + (item.New || 0), 0);
        const totalResolved = tableData.reduce((sum, item) => sum + (item.Resolved || 0), 0);
        const totalPending = tableData.reduce((sum, item) => sum + (item.Pending || 0), 0);
        const totalEscalated = tableData.reduce((sum, item) => sum + (item.Escalated || 0), 0);
        const totalReopen = tableData.reduce((sum, item) => sum + (item.Reopen || 0), 0);
        const totalOnHold = tableData.reduce((sum, item) => sum + (item.OnHold || 0), 0);

        body.push([
          { content: "Total", styles: { halign: "left", fontStyle: "bold", fillColor: "#f8f9fa" } },
          { content: formatWithCommas(totalTotal), styles: { halign: "center", fontStyle: "bold", fillColor: "#f8f9fa" } },
          { content: formatWithCommas(totalNew), styles: { halign: "center", fontStyle: "bold", fillColor: "#f8f9fa" } },
          { content: formatWithCommas(totalResolved), styles: { halign: "center", fontStyle: "bold", fillColor: "#f8f9fa" } },
          { content: formatWithCommas(totalPending), styles: { halign: "center", fontStyle: "bold", fillColor: "#f8f9fa" } },
          { content: formatWithCommas(totalEscalated), styles: { halign: "center", fontStyle: "bold", fillColor: "#f8f9fa" } },
          { content: formatWithCommas(totalReopen), styles: { halign: "center", fontStyle: "bold", fillColor: "#f8f9fa" } },
          { content: formatWithCommas(totalOnHold), styles: { halign: "center", fontStyle: "bold", fillColor: "#f8f9fa" } },
        ]);
      } else {
        body.push([
          { content: "No Data Found", colSpan: 8, styles: { halign: "center", textColor: [255, 0, 0], fontStyle: "bold" } },
        ]);
      }


      const pdf = new jsPDF('landscape', 'mm', 'a4', { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const logoWidth = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' ? 25 : 30;
      const logoHeight = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' ? 20 : 10;
      pdf.addImage(getLogo(companyCode), 'PNG', 15, 5, logoWidth, logoHeight);

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' ? 43 : 17;
      pdf.addImage(eOpsLogo, 'PNG', eOpsLogoXPosition, companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' ? 12 : 17, eOpsLogoWidth, eOpsLogoHeight);

      pdf.setFontSize(10);
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);

      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, { align: 'center' });
      pdf.text(`APMS Complaints Summary for ${offName}`, pageWidth / 2, 18, { align: 'center' });
      pdf.setFontSize(10);
      pdf.text(title, pageWidth / 2, 25, { align: 'center' });

      pdf.autoTable({
        startY: 28,
        head: headers,
        body: body,
        styles: { cellPadding: 1, fontSize: 8, halign: "center", lineWidth: 0.25, lineColor: "white" },
        margin: { top: 2 },
        theme: "striped",
        headStyles: { valign: "middle", fillColor: "#2980ba" },
        columnStyles: { 0: { halign: "left" } },
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.text(`Page ${i} of ${totalPages}`, pageWidth - 45, pageHeight - 10);
      }

      if (print) {
        pdf.save(`${title}.pdf`);
      } else {
        resolve(pdf);
      }
    });
  };

  const exportToExcel = () => {
    let offName = officeName ? officeName : 'MEPCO Region';
    let dateToPrint = convertDate(new Date());
    const title = dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
      ? `APMS Complaints Summary Report of ${offName} for ${dateFrom}`
      : `APMS Complaints Summary Report of ${offName} from ${dateFrom ? convertDate(dateFrom) : '-'} to ${dateTo ? convertDate(dateTo) : '-'}`;
    const table = tableRef.current;
    const wb = XLSX.utils.table_to_book(table, { sheet: 'Sheet1' });
    const ws = wb.Sheets['Sheet1'];

    const headers = [
      [
        OffLevel == 2 ? "Circle"
          : OffLevel == 3 ? "Division"
            : OffLevel == 4 ? "Sub-Division"
              : OffLevel == 5 ? "Sub-Division"
                : "",
        'Total',
        'New',
        'Resolved',
        'Pending',
        'Escalated',
        'Reopen',
        'On Hold'
      ]
    ];

    const headingText = title;
    XLSX.utils.sheet_add_aoa(ws, [[headingText]], { origin: "A1" });

    const range = XLSX.utils.decode_range(ws["!ref"]);
    const columnCount = range.e.c - range.s.c + 1;

    ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: columnCount - 1 } }];

    if (!ws["A1"]) ws["A1"] = {};
    ws["A1"].s = { alignment: { horizontal: "center", vertical: "center" }, font: { bold: true } };

    XLSX.utils.sheet_add_aoa(ws, headers, { origin: "A2" });

    boldRows(ws, 1, 1);

    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout]), `${title}.xlsx`);
  };

  const printPDF = async () => {
    let pdf = await DownloadPdf(false);
    const pdfUrl = pdf.output('bloburl');

    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.top = '0';
    iframe.style.left = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    const cancelButton = document.createElement('button');
    cancelButton.textContent = 'Cancel';
    cancelButton.style.position = 'fixed';
    cancelButton.style.top = '20px';
    cancelButton.style.right = '20px';
    cancelButton.style.padding = '10px 20px';
    cancelButton.style.backgroundColor = '#ff4d4d';
    cancelButton.style.color = 'white';
    cancelButton.style.border = 'none';
    cancelButton.style.borderRadius = '5px';
    cancelButton.style.cursor = 'pointer';
    document.body.appendChild(cancelButton);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    cancelButton.addEventListener('click', () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  function getCurrentDateFormatted(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const options = { month: 'short' };
    const month = date.toLocaleString('en-US', options);
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  }

  // Fetch subDivisions for code == 10
  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setIsLoading(true);
        const myHeaders = new Headers();
        myHeaders.append('Authorization', token);
        const formdata = new FormData();
        formdata.append('companyCode', selectedCompanyCode);
        const requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow',
        };
        try {
          const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
          if (response.ok) {
            const result = await response.json();
            if (result.status === '200') {
              setSubDivisions(result.message);
              setApiData(result.message);
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some(item => item.circleCode === curr.circleCode)) {
                  acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              console.error('Error fetching subDivisions:', result.message);
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          console.error('Error fetching subDivisions:', error);
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setIsLoading(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some(item => item.circleCode === curr.circleCode)) {
          acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCode(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || '');

    if (code == 10 && selectedCompany) {
      setIsLoading(true);
      const myHeaders = new Headers();
      myHeaders.append('Authorization', token);
      const formdata = new FormData();
      formdata.append('companyCode', selectedCompany);
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      try {
        const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === '200') {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode('');
            setSelectedDivision('');
            setSelectedSubDivision('');
            setCircleName('');
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some(item => item.circleCode === curr.circleCode)) {
                acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            console.error('Error fetching subDivisions:', result.message);
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error('Error fetching subDivisions:', error);
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setIsLoading(false);
      }
    } else if (!selectedCompany) {
      setOfficeName('PITC');
      setCircleCode('');
      setSelectedDivision('');
      setSelectedSubDivision('');
      setCircleName('');
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value ? parseInt(event.target.value) : '';
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setIsLoading(true);
      const myHeaders = new Headers();
      myHeaders.append('Authorization', token);
      const formdata = new FormData();
      formdata.append('companyCode', selectedCompanyCode);
      formdata.append('circleCode', selectedCircleCode);
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      try {
        const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === '200') {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find(circle => circle.circleCode === selectedCircleCode);
            const circleName = circle?.circleName || '';
            setOfficeName(circleName.concat(' Circle'));
            setCircleName(circleName);
            setSelectedDivision('');
            setSelectedSubDivision('');
            setFilteredSubDivisions([]);

            const uniqueDivisions = result.message
              .filter(item => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                  acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error('Error fetching subDivisions:', result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error('Error fetching subDivisions:', error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setIsLoading(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      setIsLoading(true);
      const myHeaders = new Headers();
      myHeaders.append('Authorization', token);
      const formdata = new FormData();
      formdata.append('companyCode', selectedCompanyCode);
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      try {
        const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === '200') {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode('');
            setOfficeCode(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName('');
            setSelectedDivision('');
            setSelectedSubDivision('');
            setFilteredSubDivisions([]);

            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error('Error fetching subDivisions:', result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error('Error fetching subDivisions:', error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setIsLoading(false);
      }
    } else if (selectedCircleCode) {
      setCircleCode(selectedCircleCode);
      setOfficeCode(selectedCircleCode);
      const circle = filteredCircles.find(circle => circle.circleCode === selectedCircleCode);
      const circleName = circle?.circleName || '';
      setOfficeName(circleName.concat(' Circle'));
      setCircleName(circleName);
      setSelectedDivision('');
      setSelectedSubDivision('');
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(item => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (!acc.some(division => division.divisionCode === item.divisionCode)) {
            acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      setCircleCode('');
      setSelectedDivision('');
      setSelectedSubDivision('');
      setFilteredSubDivisions([]);
      if (roleTypeName == 'Technical') {
        if (offCode) {
          setOfficeCode(offCode == 10 ? 15 : offCode);
          let officeName = getName(offCode == 10 ? '15' : offCode.toString(), subDivisions);
          setOfficeName(officeName.concat(' Region'));
          setCircleName('');
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some(item => item.circleCode === curr.circleCode)) {
              acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (!acc.some(division => division.divisionCode === item.divisionCode)) {
              acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == 'Commercial') {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setIsLoading(true);
      const myHeaders = new Headers();
      myHeaders.append('Authorization', token);
      const formdata = new FormData();
      formdata.append('companyCode', selectedCompanyCode);
      formdata.append('divisionCode', selectedDivisionCode);
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      try {
        const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === '200') {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const division = filteredDivisions.find(division => division.divisionCode === selectedDivisionCode);
            const divisionName = division?.divisionName || '';
            setOfficeName(divisionName.concat(' Division'));
            setSelectedSubDivision('');
            const uniqueSubDivisions = result.message
              .filter(item => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
                  acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            console.error('Error fetching subDivisions:', result.message);
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error('Error fetching subDivisions:', error);
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setIsLoading(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCode(selectedDivisionCode);
      const divisionName = filteredDivisions.find(division => division.divisionCode === selectedDivisionCode)?.divisionName || '';
      setOfficeName(divisionName.concat(' Division'));
      setSelectedSubDivision('');
      const uniqueSubDivisions = subDivisions
        .filter(item => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
            acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision('');
      setOfficeCode(circleCode ? circleCode : offCode);
      let officeName = getName(circleCode ? circleCode.toString() : offCode.toString(), subDivisions);
      setOfficeName(officeName.concat(' Circle'));
      setSelectedSubDivision('');
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(item => item.circleCode == (circleCode ? circleCode : offCode))
        .reduce((acc, item) => {
          if (!acc.some(division => division.divisionCode === item.divisionCode)) {
            acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setIsLoading(true);
      const myHeaders = new Headers();
      myHeaders.append('Authorization', token);
      const formdata = new FormData();
      formdata.append('companyCode', selectedCompanyCode);
      formdata.append('subDivisionCode', selectedSubDivisionCode);
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      try {
        const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === '200') {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(sub => sub.subDivisionCode === selectedSubDivisionCode);
            const subDivisionName = subDivision?.subDivisionName || '';
            setOfficeName(subDivisionName.concat(' Sub Division'));
          } else {
            console.error('Error fetching subDivisions:', result.message);
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error('Error fetching subDivisions:', error);
        setSubDivisions([]);
      } finally {
        setIsLoading(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCode(selectedSubDivisionCode);
      const subDivisionName = filteredSubDivisions.find(sub => sub.subDivisionCode === selectedSubDivisionCode)?.subDivisionName || '';
      setOfficeName(subDivisionName.concat(' Sub Division'));
    } else {
      setSelectedSubDivision('');
      let officeName = getName(selectedDivision ? selectedDivision.toString() : offCode.toString(), subDivisions);
      setOfficeName(officeName.concat(' Division'));
      setOfficeCode(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == 'Technical') {
      if (offCode) {
        setOfficeCode(offCode == 10 ? 15 : offCode);
        let offName = getName(offCode == 10 ? '15' : offCode.toString(), subDivisions);
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == 'Commercial') {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            setOfficeCode(15);
            setOfficeName("PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 4));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }else if (cfcLevelId == 5) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 5));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some(item => item.circleCode === curr.circleCode)) {
            acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some(item => item.circleCode === curr.circleCode)) {
            acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        setCircleCode(offCode.slice(0, 3));
        const uniqueDivisions = subDivisions
          .filter(item => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (!acc.some(division => division.divisionCode === item.divisionCode)) {
              acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if ((hierarchy == 4 || cfcLevelId == 4) || (hierarchy == 5 || cfcLevelId == 5)) {
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter(item => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
              acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);



  const connectionTypes = [
    OffLevel == 2
      ? "Circle"
      : OffLevel == 3
        ? "Division"
        : OffLevel == 4
          ? "Sub-Division"
          : OffLevel == 5
            ? "Sub-Division"
            : "",
    'Total',
    'New',
    'Resolved',
    'Pending',
    'Escalated',
    'Reopen',
    'On Hold'
  ];


  const fetchData = async (officeCode, dateFrom, dateTo) => {
    setIsLoading(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "officeCode": officeCode?.toString() || code.slice(0, 2),
      "dateFrom": dateFrom,
      "dateTo": dateTo
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    try {
      // Call both APIs in parallel
      const [statsResponse, escalatedResponse] = await Promise.all([
        fetch(cfpBaseUrl + "apms/getAPMSComplaintsStatsStatusWise", requestOptions),
        fetch(cfpBaseUrl + "apms/getAPMSEscalatedComplaintsStatsOfficeWise", {
          ...requestOptions,
          body: raw
        })
      ]);

      const statsResult = await statsResponse.json();
      const escalatedResult = await escalatedResponse.json();

      let mergedData = {};

      // Process stats from first API (Total, New, Resolved, Pending, Reopen, OnHold)
      if (statsResult.status === "200" && statsResult.data) {
        const statsData = statsResult.data;
        statsData.forEach(item => {
          const offCode = item.OfficeCode || item.officeCode;
          const offName = item.OfficeName || item.officeName;

          if (!mergedData[offCode]) {
            mergedData[offCode] = {
              OfficeCode: offCode,
              OfficeName: offName,
              Total: 0,
              New: 0,
              Resolved: 0,
              Pending: 0,
              Escalated: 0,
              Reopen: 0,
              OnHold: 0
            };
          }

          const status = item.Status || item.status;
          const count = item.TotalCount || item.totalCount || item.Count || item.count || 0;

          if (status === "New" || status === "new") mergedData[offCode].New += count;
          else if (status === "Resolved" || status === "resolved") mergedData[offCode].Resolved += count;
          else if (status === "Pending" || status === "pending") mergedData[offCode].Pending += count;
          else if (status === "Reopen" || status === "reopen" || status === "Re-Open" || status === "re-open") mergedData[offCode].Reopen += count;
          else if (status === "OnHold" || status === "onhold" || status === "On Hold" || status === "on hold" || status === "On-Hold") mergedData[offCode].OnHold += count;

          mergedData[offCode].Total += count;
        });
      }

      // Process Escalated from second API
      if (escalatedResult.status === "200" && escalatedResult.data) {
        const escalatedData = escalatedResult.data;
        escalatedData.forEach(item => {
          const offCode = item.OfficeCode || item.officeCode;
          const offName = item.OfficeName || item.officeName;
          const escalatedCount = item.TotalCount || item.totalCount || item.Count || item.count || item.Escalated || item.escalated || 0;

          if (!mergedData[offCode]) {
            mergedData[offCode] = {
              OfficeCode: offCode,
              OfficeName: offName,
              Total: 0,
              New: 0,
              Resolved: 0,
              Pending: 0,
              Escalated: 0,
              Reopen: 0,
              OnHold: 0
            };
          }

          mergedData[offCode].Escalated = escalatedCount;
          // Add escalated to total
          mergedData[offCode].Total += escalatedCount;
        });
      }

      const dataArray = Object.values(mergedData);

      const filteredData = dataArray.filter(item => {
        const itemCode = String(item.OfficeCode);
        const targetCode = String(officeCode ? officeCode : code.slice(0, 2));
        if (targetCode.length === 5) {
          return itemCode === targetCode;
        } else {
          return itemCode.startsWith(targetCode) && itemCode.length === targetCode.length + 1;
        }
      });

      console.log("Filtered Data:", filteredData);
      setTableData(filteredData);

      if (filteredData.length === 0) {
        console.warn("No data found for the selected officeCode.");
      }

      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setTableData([]);
      setIsLoading(false);
    }
  };




  function formatWithCommas(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const tableStyle = {
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: '5px',
    textAlign: 'center',
    fontSize: '15px',
  };


  const thTdStyle = {
    border: 'none',
    padding: '0px 8px',
    fontSize: '14px'
  };

  const subdivthTdStyle = {
    border: 'none',
    padding: '6px 7px',
    backgroundColor: '#d5e5fc',
    fontSize: '15px',
    fontWeight: 'bold'
  };

  const headerStyle = {
    backgroundColor: '#eeeff0',
    border: 'none',
    fontSize: '15px',
    paddingTop: '10px'
  };

  const currentFilters = {
    officeCode, dateFrom, dateTo
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }

    const hasChanged = JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [
    officeCode, dateFrom, dateTo
  ]);

  const handleGoClick = () => {
    fetchData(officeCode, dateFrom, dateTo)

    setLastAppliedFilters({ ...currentFilters });

    setIsGoDisabled(true);
  };

  const noDataAvailable = () => {
    alert("No data available to export or print.");
  };
  return (
    <>

      <Box className='form-box'>
        <div style={{ display: 'flex', flexDirection: "row" }}>
          <Box className='application-table' style={{ marginRight: '10px', height: '100%' }}>
            <h3 style={{ color: '#006ad1', marginBottom: '10px' }}>APMS Complaints Summary</h3>
            <div className='div-datagrid' style={{ height: '100%' }}>
              <div className='reports-container' >
                <div className='filter-fields' style={{ width: '75%', justifyContent: 'flex-start', gap: '15px' }}>


                  <div className='field-container'>
                    <Typography className='field-label'> Date From</Typography>
                    <input type='date' className='date-field' value={dateFrom} max={getTodayIsoDate()} onChange={(e) => { setDateFrom(clampIsoDateToToday(e.target.value)); }} />
                  </div>
                  <div className='field-container'>
                    <Typography className='field-label'> Date To</Typography>
                    <input type='date' className='date-field' value={dateTo} max={getTodayIsoDate()} onChange={(e) => { setDateTo(clampIsoDateToToday(e.target.value)); }} />
                  </div>
                  {code == 10 && (
                    <div className="field-container">
                      <Typography className="field-label">Company</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: 'white' }}
                        value={selectedCompanyCode}
                        onChange={handleChangeCompany}
                      >
                        <option value="10">Select Company</option>
                        <option value="11">LESCO</option>
                        <option value="12">GEPCO</option>
                        <option value="13">FESCO</option>
                        <option value="14">IESCO</option>
                        <option value="15">MEPCO</option>
                        <option value="26">PESCO</option>
                        <option value="27">HAZECO</option>
                        <option value="37">HESCO</option>
                        <option value="38">SEPCO</option>
                        <option value="48">QESCO</option>
                        <option value="59">TESCO</option>
                      </select>
                    </div>
                  )}

                  {hierarchy <= 2 && (
                    <div className="field-container">
                      <Typography className="field-label">Circle</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: 'white' }}
                        value={circleCode || ''}
                        onChange={handleCircleChange}
                      >
                        <option value="">All Circle</option>
                        {filteredCircles.map((circle) => (
                          <option key={circle.circleCode} value={circle.circleCode}>
                            {circle.circleName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {hierarchy <= 3 && (
                    <div className="field-container">
                      <Typography className="field-label">Division</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: 'white' }}
                        value={selectedDivision || ''}
                        onChange={handleDivisionChange}
                        disabled={!circleCode}
                      >
                        <option value="">All Division</option>
                        {filteredDivisions.map((division) => (
                          <option key={division.divisionCode} value={division.divisionCode}>
                            {division.divisionName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {hierarchy <= 4 && (
                    <div className="field-container">
                      <Typography className="field-label">Sub-Division</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: 'white' }}
                        value={selectedSubDivision || ''}
                        onChange={handleSubDivisionChange}
                        disabled={!selectedDivision}
                      >
                        <option value="">All Sub-Division</option>
                        {filteredSubDivisions.map((subDivision) => (
                          <option key={subDivision.subDivisionCode} value={subDivision.subDivisionCode}>
                            {subDivision.subDivisionName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  <Button
                    variant="contained"
                    color="primary"
                    style={{ marginTop: '10px' }}
                    onClick={handleGoClick}
                    disabled={isGoDisabled || isLoading}
                  >
                    Go
                  </Button>
                  <div className='field-container'>
                    <Typography className='field-label'></Typography>
                    <input style={{ display: 'none' }}></input>
                  </div>
                  <div className='field-container'>
                    <Typography className='field-label'> </Typography>
                    <input style={{ display: 'none' }} type='date' className='date-field' />
                  </div>

                </div>
                <div className="export-button-container">

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      DownloadPdf(true);
                    }}
                    style={{ height: "40px", marginLeft: "15px" }}
                  >
                    <img
                      src={pdf}
                      alt="pdf"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      exportToExcel();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={excel}
                      alt="Excel"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      printPDF();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={print}
                      alt="print"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: 'rgb(213, 229, 255)', color: 'black', marginBottom: '5px' }}>
                <Typography variant="h6" style={{ color: 'black' }}>
                  {dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
                    ? `APMS Complaints Summary Report for (${officeName}) of ${dateFrom}`
                    : `APMS Complaints Summary Report for (${officeName}) from ${dateFrom ? convertDate(dateFrom) : '-'} to ${dateTo ? convertDate(dateTo) : '-'}`}
                </Typography>
              </div>
              <table
                style={{
                  ...tableStyle,
                  tableLayout: "fixed",
                  width: "100%",
                  borderCollapse: "collapse",
                }}
                ref={tableRef}
              >
                <thead>
                  <tr style={{ position: 'sticky', top: '37px', backgroundColor: 'white', zIndex: 1 }}>
                    {connectionTypes.map((type, index) => (
                      <th
                        key={index}
                        style={{
                          width: `${100 / connectionTypes.length}%`,
                          textAlign: 'left',
                          border: '5px solid white',
                          backgroundColor: '#eeeff1',
                          color: 'black',
                          fontSize: '14px',
                          position: 'sticky',
                          top: 0,
                          zIndex: 1,
                          padding: '6px',
                          fontWeight: 'bold',
                          textAlign: 'center'
                        }}
                      >
                        {type}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tableData && tableData.length > 0 ? (
                    <>
                      {tableData.map((item, id) => (
                        <tr
                          key={id}
                          style={{ backgroundColor: "white", borderBottom: "1px solid #ccc" }}
                        >
                          <td style={{ textAlign: "left" }}>{item.OfficeName || "-"}</td>
                          <td style={{ textAlign: "center" }}>
                            {item.Total ? formatWithCommas(item.Total) : "-"}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.New ? formatWithCommas(item.New) : "-"}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.Resolved ? formatWithCommas(item.Resolved) : "-"}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.Pending ? formatWithCommas(item.Pending) : "-"}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.Escalated ? formatWithCommas(item.Escalated) : "-"}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.Reopen ? formatWithCommas(item.Reopen) : "-"}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.OnHold ? formatWithCommas(item.OnHold) : "-"}
                          </td>
                        </tr>
                      ))}

                      {/* Total Row */}
                      {tableData.length > 0 && (
                        <tr style={{ backgroundColor: '#fef5c0' }}>
                          <td style={{ textAlign: "left", fontWeight: 'bold' }}>Total</td>
                          <td style={{ textAlign: "center", fontWeight: 'bold' }}>
                            {formatWithCommas(tableData.reduce((sum, item) => sum + (item.Total || 0), 0))}
                          </td>
                          <td style={{ textAlign: "center", fontWeight: 'bold' }}>
                            {formatWithCommas(tableData.reduce((sum, item) => sum + (item.New || 0), 0))}
                          </td>
                          <td style={{ textAlign: "center", fontWeight: 'bold' }}>
                            {formatWithCommas(tableData.reduce((sum, item) => sum + (item.Resolved || 0), 0))}
                          </td>
                          <td style={{ textAlign: "center", fontWeight: 'bold' }}>
                            {formatWithCommas(tableData.reduce((sum, item) => sum + (item.Pending || 0), 0))}
                          </td>
                          <td style={{ textAlign: "center", fontWeight: 'bold' }}>
                            {formatWithCommas(tableData.reduce((sum, item) => sum + (item.Escalated || 0), 0))}
                          </td>
                          <td style={{ textAlign: "center", fontWeight: 'bold' }}>
                            {formatWithCommas(tableData.reduce((sum, item) => sum + (item.Reopen || 0), 0))}
                          </td>
                          <td style={{ textAlign: "center", fontWeight: 'bold' }}>
                            {formatWithCommas(tableData.reduce((sum, item) => sum + (item.OnHold || 0), 0))}
                          </td>
                        </tr>
                      )}
                    </>
                  ) : (
                    <tr>
                      <td
                        colSpan="8"
                        style={{
                          textAlign: "center",
                          padding: "10px",
                          fontWeight: "bold",
                          color: "red",
                          background: '#fef5c0'
                        }}
                      >
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>


              </table>

              < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={isLoading}
              >
                <CircularProgress color="inherit" />
              </Backdrop >




            </div>
          </Box>
        </div>
      </Box>

    </>
  )
}

export default APMSComplaintsSummary
